// Constants:
const $background = document.getElementById('header-overlay-background')
const $close = document.getElementById('header-overlay-close')
const $closeBarBottom = document.getElementById('header-overlay-close-bar-bottom')
const $closeBarMiddle = document.getElementById('header-overlay-close-bar-middle')
const $closeBarTop = document.getElementById('header-overlay-close-bar-top')
const $header = document.getElementsByTagName('header')[0]
const $html = document.getElementsByTagName('html')[0]
const $mobile = document.getElementById('header-mobile')
const $open = document.getElementById('header-overlay-open')
const $openBarMiddle = document.getElementById('header-overlay-open-bar-middle')
const $overlay = document.getElementById('header-overlay')

// Variables:
let isTogglable = false
let overlayToggled = false
let overlayToggling = false
let scrolled = false

// Functions:
function documentHeight() {
  const $body = document.body
  const $html = document.documentElement

  return Math.max($body.scrollHeight, $body.offsetHeight, $html.clientHeight, $html.scrollHeight, $html.offsetHeight)
}

function setScroll() {
  const scrollY = window.scrollY
  
  if (scrollY >= 0) {
    document.documentElement.dataset.scroll = scrollY
  }
}

function toggleOverlay() {
  if (!overlayToggling && isTogglable) {
    overlayToggling = true

    const dimensions = $open.getBoundingClientRect()
    
    if (!overlayToggled) {
      $background.style.display = 'block'
      $background.style.height = documentHeight() + 'px'
      $background.style.opacity = 1

      scrolled = $header.getBoundingClientRect().height < 100

      $close.style.display = 'block'
      $close.style.left = (dimensions.left - 12) + 'px'
      $close.style.top = (dimensions.top - 5) + 'px'

      setTimeout(() => {
        $close.style.top = '34px'
      }, 10)

      $closeBarBottom.classList.add('close-bar-bottom-show')
      $closeBarMiddle.classList.add('close-bar-middle-show')
      $closeBarTop.classList.add('close-bar-top-show')

      $open.style.opacity = 0;

      $overlay.style.display = 'block'
      $overlay.classList.remove('overlay-hide')
      $overlay.classList.add('overlay-show')
      
      overlayToggled = true
    } else {
      $background.style.display = 'none'
      $background.style.opacity = 0

      $closeBarBottom.classList.remove('close-bar-bottom-show')
      $closeBarMiddle.classList.remove('close-bar-middle-show')
      $closeBarTop.classList.remove('close-bar-top-show')

      $closeBarBottom.classList.add('close-bar-bottom-hide')
      $closeBarMiddle.classList.add('close-bar-middle-hide')
      $closeBarTop.classList.add('close-bar-top-hide')
      
      $close.style.top = (dimensions.top - 5) + 'px'

      if (scrolled) {
        setTimeout(() => {
          $close.style.top = '29px'
        }, 10)
      }
            
      $openBarMiddle.style.opacity = 0

      $overlay.classList.remove('overlay-show')
      $overlay.classList.add('overlay-hide')

      setTimeout(() => {
        $closeBarBottom.classList.remove('close-bar-bottom-hide')
        $closeBarTop.classList.remove('close-bar-top-hide')

        $open.style.opacity = ''

        $overlay.style.display = ''
      }, 495)

      setTimeout(() => {
        $close.classList.remove('close-hide')
        $close.style.display = ''
        $close.style.left = ''
        $close.style.top = ''

        $closeBarMiddle.classList.remove('close-bar-middle-hide')

        $openBarMiddle.style.opacity = ''

        overlayToggled = false
      }, 995)
    }

    setTimeout(() => {
      overlayToggling = false
    }, 1000)
  }
}

// Context:
$close.addEventListener('click', toggleOverlay)
$mobile.addEventListener('click', toggleOverlay)

setTimeout(() => {
  isTogglable = true

  setScroll()
}, 1000)

document.addEventListener('scroll', () => {
  setScroll()
})